import { render } from "./SessionExpiredModalWindow.vue?vue&type=template&id=5931c116&scoped=true&ts=true"
import script from "./SessionExpiredModalWindow.vue?vue&type=script&lang=ts"
export * from "./SessionExpiredModalWindow.vue?vue&type=script&lang=ts"

import "./SessionExpiredModalWindow.vue?vue&type=style&index=0&id=5931c116&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5931c116"]])

export default __exports__